import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsSavedService {
  private reinitializeSubject = new Subject<void>();

  reinitialize$ = this.reinitializeSubject.asObservable();

  constructor() {}

  triggerComponentReinitialize() {
    this.reinitializeSubject.next();
  }
}
